import { render, staticRenderFns } from "./ConfigurationHistory.vue?vue&type=template&id=5e0caafc&scoped=true&"
import script from "./ConfigurationHistory.vue?vue&type=script&lang=js&"
export * from "./ConfigurationHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0caafc",
  null
  
)

export default component.exports